import { render } from "./externalTab.vue?vue&type=template&id=4154d4bb&scoped=true"
import script from "./externalTab.vue?vue&type=script&setup=true&lang=js"
export * from "./externalTab.vue?vue&type=script&setup=true&lang=js"

import "./externalTab.vue?vue&type=style&index=0&id=4154d4bb&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4154d4bb"],['__file',"pages/EndataAuth/Account/App/components/profile/my/externalTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4154d4bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4154d4bb', __exports__)) {
    api.reload('4154d4bb', __exports__)
  }
  
  module.hot.accept("./externalTab.vue?vue&type=template&id=4154d4bb&scoped=true", () => {
    api.rerender('4154d4bb', render)
  })

}


export default __exports__